var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 89,
    viewBox: "0 0 69 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_498_446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2157 79.005H59.4545V21.1511L40.7625 39.8559L34.5676 46.0552L28.3683 39.8559L0.906616 12.3942V0L9.66781 8.76119L34.5676 33.661L59.4545 8.76119L68.2157 0V79.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67209 37.9194V79.0049H0.906616V29.1582L9.67209 37.9194Z",
    fill: "#DA5026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6527 86.468H0.906616V89H68.6527V86.468Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_498_446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.7461,
    height: 89,
    fill: "white",
    transform: "translate(0.906616)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMLetter);
export default __webpack_public_path__ + "static/media/mLetter.ed21e08171273762af4c36399824a96e.svg";
export { ForwardRef as ReactComponent };